import { Formik } from "formik";
import moment from "moment";
import React, { useState } from "react";
import { API, fileUpload } from "../../../config";
import Spin from "../../../components/Spin";
import { Label } from "../../../components/ui/label";
import CustomLabelText from "../../../components/CustomLabelText";
import Combobox from "../../../components/Combobox";
// import { useOrganization } from "../../../lib/context/OrganisationContext";
import { Input } from "../../../components/ui/input";
import { DateInputPicker } from "../../../components/DateInputPicker";
// import { formatSubcontractorName } from "../../../lib/Misc";
// import UserSelect from "../../../components/UserSelect";
// import { Loader2 } from "lucide-react";
import { Button } from "../../../components/ui/button";
import { VisualVerifySchema } from "../../../lib/Validation";

const VerifyModal = ({ data, toggleVisual, fetchData }) => {
  // const { organizationData } = useOrganization();
  const [loading, setLoading] = useState(false);

  // const [userLoading, setUserLoading] = useState(false);
  // const [userListing, setUserListing] = useState([]);
  // const [userList, setUserList] = useState([]);

  // useEffect(() => {
  //   if (userList) {
  //     let userTempListing = userList?.map((item) => ({
  //       ...item,
  //       value: item?.id,
  //       label: formatSubcontractorName(item),
  //     }));
  //     setUserListing(userTempListing || []);
  //   } else {
  //     setUserListing([]);
  //   }
  // }, [userList]);

  const handleFormSubmit = async (value) => {
    const formData = new FormData();

    formData.append(
      `date_verified`,
      value.date_verified
        ? moment(value.date_verified).format("DD-MM-YYYY")
        : "",
    );

    // formData.append(`verified_by`, value.verified_by ?? "");
    formData.append(`verified`, value.verified ?? "");

    formData.append("_method", "put");
    try {
      setLoading(true);
      const response = await fileUpload(
        `${API.GET_CDD_VISUAL}${data?.id ? `/${data?.id}` : ""}`,
        formData,
      );
      setLoading(false);
      if (response?.data) {
        toggleVisual();
        fetchData && fetchData();
      }
      return data?.data;
    } catch (error) {
      setLoading(false);
    }
  };
  return (
    <Formik
      initialValues={{
        id: data?.id ? data?.id : "",
        date_verified: data?.date_verified
          ? moment(data?.date_verified, "DD-MM-YYYY")
          : "",
        // verified_by: data?.verified_by_id ? data?.verified_by_id : "",
        verified: data?.verified ? Number(data?.verified) : 0,
        verified_using: data?.verified_using ? data?.verified_using : "",
      }}
      enableReinitialize
      onSubmit={handleFormSubmit}
      validateOnBlur={true}
      validateOnChange={true}
      validationSchema={VisualVerifySchema}
    >
      {({
        values,
        errors,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isValid,
      }) => (
        <>
          {loading && <Spin expand={true} fullscreen={true} />}
          <form
            onSubmit={handleSubmit}
            noValidate
            className="entry-section md:m-0 m-5"
          >
            <div className="form-box overflow-hidden overflow-y-auto max-h-[80vh] p-6 border rounded-lg">
              <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
                <div className="space-y-2">
                  <Label htmlFor="trust_id">
                    <CustomLabelText
                      required={true}
                      labelText="Verification Date"
                      errorField={errors?.date_verified}
                      bottomAlign={true}
                    />
                  </Label>
                  {values?.verified_using ? (
                    <Input
                      value={
                        values?.date_verified
                          ? moment(values?.date_verified)?.format("DD-MM-YYYY")
                          : ""
                      }
                      readonly
                      disabled={values?.verified_using ? true : false}
                    />
                  ) : (
                    <DateInputPicker
                      date={values?.date_verified ? values?.date_verified : ""}
                      onSelect={(e) => {
                        setFieldValue(`date_verified`, e);
                      }}
                      inputClassName="w-full"
                      className={""}
                      disabledDate={{ after: new Date() }}
                    />
                  )}
                </div>

                {/* Verified By */}

                {/* <div className="min-w-0">
                  <Label htmlFor="verified_by">
                    <CustomLabelText
                      labelText="Verified By"
                      errorField={errors?.verified_by}
                      required={true}
                      bottomAlign={true}
                    />
                  </Label>
                  <div className="relative mt-2">
                    <UserSelect
                      orgId={organizationData?.organizationId}
                      frameworkData={userListing} // List of vendors
                      optionType="User"
                      handleSelect={(e) => {
                        setFieldValue(`verified_by`, e);
                      }}
                      name="verified_by"
                      disabled={values?.verified_using ? true : false}
                      initialValue={
                        values?.verified_by ? values?.verified_by : ""
                      }
                      authUser={true}
                      setUserList={setUserList}
                      setUserLoading={setUserLoading}
                      onClear={() => {
                        setFieldValue(`verified_by`, "");
                      }}
                      className={
                        errors?.verified_by &&
                        `focus-visible:ring-red-500 border-red-500`
                      }
                      loading={userLoading}
                    />
                    {userLoading && (
                      <span className="absolute top-2 right-2 animate-spin">
                        <Loader2 width={20} height={20} />
                      </span>
                    )}
                  </div>
                </div> */}

                {/* VERIFIED */}

                <div className="space-y-2">
                  <Label htmlFor="trust_id">
                    <CustomLabelText
                      required={true}
                      labelText="Verified"
                      errorField={errors?.verified}
                      bottomAlign={true}
                    />
                  </Label>

                  <Combobox
                    options={[
                      { label: "Yes", value: 1 },
                      { label: "No", value: 0 },
                    ]}
                    disabled={values?.verified_using ? true : false}
                    value={values.verified}
                    placeholder="Select"
                    onChange={(value) => setFieldValue(`verified`, value)}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-end">
              <Button type="submit" disabled={!isValid}>
                Save
              </Button>
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => {
                  e.preventDefault();
                  toggleVisual();
                }}
                variant="secondary"
              >
                Cancel
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
};

export default VerifyModal;
